import { MenuIcon } from 'lucide-react';
import { Dispatch, SetStateAction } from 'react';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const AllItems = ({
  setShowMainMenu,
}: {
  setShowMainMenu: Dispatch<SetStateAction<boolean>>;
}) => (
  <li
    // eslint-disable-next-line tailwindcss/no-custom-classname
    className="mr-4 hidden lg:block"
  >
    <button
      onClick={() =>
        typeof setShowMainMenu === 'function' && setShowMainMenu(true)
      }
      className="flex items-center justify-center gap-2 font-medium outline-none"
    >
      <MenuIcon className="h-4 w-4" strokeWidth={2.5} />
      <span
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="fancy-underline block whitespace-nowrap"
      >{t`All Items`}</span>
    </button>
  </li>
);

export default AllItems;
